export type EmployeeGroupType = {
  id: number;
  name: string;
  type: string;
  memberCount: number;
};

export type SearchEmployeeGroupsQueryVariablesType = {
  term: string;
  offset: number;
  locationId: string;
  typeFilters: string[];
  limit: number;
};

export type SearchEmployeeGroupsQueryType = {
  __typename?: 'Query';
  searchEmployeeGroups: {
    groups: EmployeeGroupType[];
  };
};
